// Node modules import
import createPersistedState from "vuex-persistedstate";
import createMutationsSharer from "vuex-shared-mutations";

// Imports Vuex Modules
// Please refer to https://vuex.vuejs.org/guide/modules.html
// for more information on vuex modules
import global from "./modules/global";
import header from "./modules/header";
import auth from "./modules/auth";
import menus from "./modules/menus";
import footer from "./modules/footer";
import prompt from "./modules/prompt";
import rules from "./modules/rules";
import config from "./modules/config";
import survey from "./modules/survey";
import abilityPlugin from "./plugin/ability.js";

const store = {
  modules: {
    header,
    global,
    auth,
    menus,
    footer,
    prompt,
    rules,
    config,
    survey
  },
  plugins: [
    createPersistedState({
      key: "ui-internet-client",
      paths: [
        "auth",
        "header.userProfile.userName",
        "header.userProfile.roles",
        "header.userProfile.userId",
        "header.userProfile.userName",
        "header.userProfile.sgID",
        "header.userProfile.sgIDType",
        "header.userProfile.profileType",
        "header.userProfile.nric",
        "header.userProfile.isValidated",
        "header.userProfile.canImpersonate",
        "header.isImpersonating",
        "header.hasProfile",
        "survey"
      ],
      fetchBeforeUse: true
    }),
    abilityPlugin,
    createMutationsSharer({
      predicate: [
        "auth/setSignedIn",
        "auth/setWasIdle",
        "auth/setAnyActiveTab",
        "auth/setLoginTime",
        "auth/setIsReminded",
        "auth/setIsSessionActive",
        "auth/setAccessToken",
        "auth/setOriginToken",
        "survey/setHasFilledSurvey",
        "header/setUserName",
        "header/setRoles",
        "header/setIsValidated",
        "header/setHasProfileTo",
        "header/setCanImpersonate",
        "header/setIsImpersonating",
        "header/setAdditionalProfileProperties",
        "auth/setIsLoginError"
      ]
    })
  ]
};

export default store;
